<div *ngIf="log" class="log__container">
  <sbnb-log-detail-sidebar-item *ngFor="let logItem of log.attributes" [log]="logItem"></sbnb-log-detail-sidebar-item>
</div>
